/** Format a conversation's plain text for the existing HTML post renderer. */
export function plainTextToPostHtml(value: string): string | undefined {
	const text = value.trim().replace(/\r\n?/g, "\n");
	if (!text) return undefined;

	const escapeHtml = (part: string) =>
		part.replace(/[&<>"']/g, (character) => {
			switch (character) {
				case "&":
					return "&amp;";
				case "<":
					return "&lt;";
				case ">":
					return "&gt;";
				case '"':
					return "&quot;";
				default:
					return "&#39;";
			}
		});

	return text
		.split(/\n\s*\n/)
		.map(
			(paragraph) => `<p>${escapeHtml(paragraph).replace(/\n/g, "<br>")}</p>`,
		)
		.join("");
}

/** Keep the required database title useful for links and search, without asking for one. */
export function deriveConversationTitle(
	body: string,
	hasImage = false,
	hasLink = false,
): string {
	const normalized = body.replace(/\s+/g, " ").trim();
	if (normalized) return normalized.slice(0, 120).trimEnd();
	if (hasImage) return "Shared an image";
	if (hasLink) return "Shared a link";
	return "Conversation";
}

/** New quick conversations repeat the generated title in their body. */
export function isBodyOnlyConversation(post: {
	title: string;
	body?: string | null;
	kind?: string | null;
	media?: { kind: string }[] | null;
}): boolean {
	if (post.kind && post.kind !== "standard") return false;
	const plain = (post.body ?? "")
		.replace(/<br\s*\/?\s*>/gi, " ")
		.replace(/<[^>]+>/g, " ")
		.replace(/&(?:amp|lt|gt|quot|#39);/g, (entity) => {
			const decoded: Record<string, string> = {
				"&amp;": "&",
				"&lt;": "<",
				"&gt;": ">",
				"&quot;": '"',
				"&#39;": "'",
			};
			return decoded[entity] ?? entity;
		});
	if (plain.trim()) return post.title === deriveConversationTitle(plain);
	return (
		(post.title === "Shared an image" &&
			Boolean(post.media?.some((item) => item.kind === "image"))) ||
		(post.title === "Shared a link" &&
			Boolean(post.media?.some((item) => item.kind === "embed")))
	);
}
